class StarterPackageBundle {
  constructor(element) {
    this.element = element;

    this.cart = document.querySelector("cart-drawer");
    this.cartType = this.cart?.dataset.cartType || "page";
    this.errorWrapper = this.element.querySelector(
      ".product-form__error-message-wrapper",
    );
    this.errorMessage = this.element.querySelector(
      "[data-starter-package-error]",
    );
    this.productForm = document.getElementById(
      `product-form-${this.element.dataset.sectionId}`,
    );
    this.discountRate = 0.15;
    this.onVariantChange = () => this.updatePackagePrices();

    this.element
      .querySelectorAll("a.mm-starter-package__product-title")
      .forEach((link) => {
        link.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          window.location.href = link.href;
        });
      });
    this.element.addEventListener("click", this.onClick.bind(this));
    this.element.addEventListener("change", this.onChange.bind(this));
    document.addEventListener("variantChangeEnd", this.onVariantChange);
    this.updatePackagePrices();
    this.updatePackageValidation();
    this.updateExpandedStates();
  }

  updateExpandedStates() {
    this.element
      .querySelectorAll("[data-starter-package-card]")
      .forEach((card) => {
        const packageInput = card.querySelector("[data-package-input]");
        const packageToggle = card.querySelector("[data-package-toggle]");
        packageToggle?.setAttribute(
          "aria-expanded",
          String(Boolean(packageInput?.checked)),
        );
      });
  }

  onClick(event) {
    const submitButton = event.target.closest("[data-starter-package-submit]");
    if (submitButton) {
      event.preventDefault();
      this.addPackageToCart(submitButton);
      return;
    }

    const packageToggle = event.target.closest("[data-package-toggle]");
    if (!packageToggle) return;

    const selectedPackageCard = packageToggle.closest(
      "[data-starter-package-card]",
    );
    const packageInput = selectedPackageCard?.querySelector(
      "[data-package-input]",
    );
    if (!packageInput || packageInput.disabled) return;

    event.preventDefault();
    packageInput.checked = !packageInput.checked;
    packageInput.dispatchEvent(new Event("change", { bubbles: true }));
    this.updatePackageValidation();
    this.updateExpandedStates();
  }

  onChange(event) {
    if (!event.target.matches("[data-package-input], [data-package-option]"))
      return;
    this.hideErrorMessage();
    this.updatePackagePrices();
    this.updatePackageValidation();
    this.updateExpandedStates();
  }

  formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || "DKK";
    const locale = document.documentElement.lang || "da-DK";

    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
    }).format(cents / 100);
  }

  getCurrentBoardPrice() {
    const variantOptions = document.querySelector(
      `variant-options[data-section="${this.element.dataset.sectionId}"]`,
    );
    return Number(
      variantOptions?.currentVariant?.price ||
        this.element.dataset.currentVariantPrice ||
        0,
    );
  }

  getCurrentBoardOriginalPrice() {
    const variantOptions = document.querySelector(
      `variant-options[data-section="${this.element.dataset.sectionId}"]`,
    );
    const variant = variantOptions?.currentVariant;
    if (variant?.compare_at_price > variant?.price) {
      return Number(variant.compare_at_price);
    }

    return Number(
      variant?.price || this.element.dataset.currentVariantOriginalPrice || 0,
    );
  }

  getDiscountedPrice(price, originalPrice) {
    return originalPrice > price
      ? price
      : price - Math.floor(price * this.discountRate);
  }

  updateDisplayedLinePrice(container, price, originalPrice) {
    const originalElement = container?.querySelector("s");
    const finalElement = container?.querySelector("strong");
    if (!originalElement || !finalElement || !price) return;

    originalElement.textContent = this.formatMoney(originalPrice || price);
    finalElement.textContent = this.formatMoney(
      this.getDiscountedPrice(price, originalPrice || price),
    );
  }

  updateDisplayedLinePrices(card, packageInput) {
    const fixedRows = card.querySelectorAll(
      ".mm-starter-package__products .mm-starter-package__product-row:not(.mm-starter-package__product-row--board)",
    );
    const fixedPrices = (packageInput?.dataset.fixedVariantPrices || "")
      .split(",")
      .map((price) => Number(price.trim()))
      .filter(Boolean);
    const fixedOriginalPrices = (
      packageInput?.dataset.fixedVariantOriginalPrices || ""
    )
      .split(",")
      .map((price) => Number(price.trim()))
      .filter(Boolean);

    fixedRows.forEach((row, index) => {
      this.updateDisplayedLinePrice(
        row,
        fixedPrices[index],
        fixedOriginalPrices[index] || fixedPrices[index],
      );
    });

    card.querySelectorAll("[data-package-option]").forEach((option) => {
      this.updateDisplayedLinePrice(
        option.closest(".mm-starter-package__magnet-option"),
        Number(option.dataset.price || 0),
        Number(option.dataset.originalPrice || option.dataset.price || 0),
      );
    });
  }

  getPackagePrices(packageInput, original = false) {
    const fixedPrices = (original
      ? packageInput?.dataset.fixedVariantOriginalPrices
      : packageInput?.dataset.fixedVariantPrices || "")
      .split(",")
      .map((price) => Number(price.trim()))
      .filter(Boolean);

    const card = packageInput?.closest("[data-starter-package-card]");
    const optionPrices = Array.from(
      card?.querySelectorAll("[data-package-option]:checked") || [],
    ).map((option) =>
      Number(
        original ? option.dataset.originalPrice || option.dataset.price : option.dataset.price || 0,
      ),
    );

    return [
      original ? this.getCurrentBoardOriginalPrice() : this.getCurrentBoardPrice(),
      ...fixedPrices,
      ...optionPrices,
    ];
  }

  updatePackageValidation() {
    this.element
      .querySelectorAll("[data-starter-package-card]")
      .forEach((card) => {
        const packageInput = card.querySelector("[data-package-input]");
        const submitButton = card.querySelector(
          "[data-starter-package-submit]",
        );
        const helpText = card.querySelector("[data-package-help]");
        if (!packageInput || !submitButton || packageInput.disabled) return;

        const requiresOption = packageInput.hasAttribute(
          "data-requires-option",
        );
        const hasOption = Boolean(
          card.querySelectorAll("[data-package-option]:checked").length >=
            Number(packageInput.dataset.minOptions || 1),
        );
        const isValid = !requiresOption || hasOption;

        submitButton.disabled = !isValid;
        helpText?.toggleAttribute("hidden", isValid);
      });
  }

  updatePackagePrices() {
    this.element.querySelectorAll("[data-board-price]").forEach((element) => {
      element.textContent = this.formatMoney(this.getCurrentBoardOriginalPrice());
    });
    this.element
      .querySelectorAll("[data-board-discounted-price]")
      .forEach((element) => {
        element.textContent = this.formatMoney(
          this.getDiscountedPrice(
            this.getCurrentBoardPrice(),
            this.getCurrentBoardOriginalPrice(),
          ),
        );
      });

    this.element
      .querySelectorAll("[data-starter-package-card]")
      .forEach((card) => {
        const packageInput = card.querySelector("[data-package-input]");
        this.updateDisplayedLinePrices(card, packageInput);
        const prices = this.getPackagePrices(packageInput);
        const originalPrices = this.getPackagePrices(packageInput, true);
        const originalPrice = originalPrices.reduce(
          (sum, price) => sum + price,
          0,
        );
        const selectedOptionCount = card.querySelectorAll(
          "[data-package-option]:checked",
        ).length;
        const minOptions = Number(packageInput?.dataset.minOptions || 1);
        const discountApplies =
          !packageInput?.hasAttribute("data-requires-option") ||
          selectedOptionCount >= minOptions;
        const packagePrice = discountApplies
          ? prices.reduce(
              (sum, price, index) =>
                sum +
                this.getDiscountedPrice(price, originalPrices[index] || price),
              0,
            )
          : prices.reduce((sum, price) => sum + price, 0);
        const savings = originalPrice - packagePrice;
        const discountPercent = Math.min(
          ...prices.map((price, index) => {
            const original = originalPrices[index] || price;
            return Math.round(
              (1 - this.getDiscountedPrice(price, original) / original) * 100,
            );
          }),
        );

        card.querySelector("[data-package-discount]").textContent =
          `spar ${discountPercent}%`;

        card.querySelectorAll("[data-package-price]").forEach((element) => {
          element.textContent = originalPrice
            ? this.formatMoney(packagePrice)
            : "—";
        });
        card.querySelectorAll("[data-package-compare]").forEach((element) => {
          element.textContent =
            originalPrice && discountApplies
              ? this.formatMoney(originalPrice)
              : "";
          element.hidden = !discountApplies;
        });
        card.querySelectorAll("[data-package-savings]").forEach((element) => {
          element.textContent = originalPrice
            ? `Du sparer ${this.formatMoney(savings)}`
            : "";
        });
      });
  }

  getSelectedPackage() {
    return this.element.querySelector("[data-package-input]:checked");
  }

  getCurrentBoardVariantId() {
    const input =
      this.productForm?.querySelector('input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return Number(input?.value || 0);
  }

  getSelectedOptions() {
    const selectedPackage = this.getSelectedPackage();
    const card = selectedPackage?.closest("[data-starter-package-card]");

    return Array.from(
      card?.querySelectorAll("[data-package-option]:checked") || [],
    )
      .filter((option) => !option.disabled)
      .map((option) => ({
        id: Number(option.value || 0),
        title:
          option.dataset.title || option.closest("label")?.textContent.trim(),
      }))
      .filter((magnet) => magnet.id);
  }

  getPackageItems() {
    const selectedPackage = this.getSelectedPackage();
    const boardVariantId = this.getCurrentBoardVariantId();

    if (!selectedPackage || selectedPackage.disabled)
      throw new Error("Vælg en tilgængelig starterpakke.");
    if (!boardVariantId) throw new Error("Vælg en tavlevariant først.");

    const selectedOptions = this.getSelectedOptions();
    if (selectedOptions.length < Number(selectedPackage.dataset.minOptions || 1))
      throw new Error(
        "Vælg mindst to magnetsæt for at få pakkerabatten og tilføje pakken.",
      );

    const items = [
      {
        id: boardVariantId,
        quantity: 1,
      },
    ];

    const fixedVariantIds = (selectedPackage.dataset.fixedVariantIds || "")
      .split(",")
      .map((id) => Number(id.trim()))
      .filter(Boolean);

    fixedVariantIds.forEach((id) => {
      items.push({
        id,
        quantity: 1,
      });
    });

    if (selectedOptions.length) {
      selectedOptions.forEach((option) => {
        items.push({
          id: option.id,
          quantity: 1,
        });
      });
    }

    return items;
  }

  getCartSections() {
    return this.cart && typeof this.cart.getSectionsToRender === "function"
      ? this.cart.getSectionsToRender().map((section) => section.id)
      : [];
  }

  getPackageOrderAttributes() {
    return {
      Pakke: this.getSelectedPackage()?.dataset.packageTitle || "",
    };
  }

  setLoading(submitButton, isLoading) {
    if (!submitButton) return;

    submitButton.toggleAttribute("aria-disabled", isLoading);
    submitButton.classList.toggle("loading", isLoading);
    submitButton
      .querySelector(".loading-overlay__spinner")
      ?.classList.toggle("hidden", !isLoading);
  }

  showErrorMessage(message) {
    if (!message) return;

    publish(PUB_SUB_EVENTS.cartError, {
      source: "starter-package-bundle",
      errors: message,
      message,
    });

    if (this.errorWrapper && this.errorMessage) {
      this.errorMessage.textContent = message;
      this.errorWrapper.removeAttribute("hidden");
    }
  }

  hideErrorMessage() {
    this.errorWrapper?.setAttribute("hidden", "");
    if (this.errorMessage) this.errorMessage.textContent = "";
  }

  renderCart(response) {
    if (!this.cart) {
      window.location = window.routes.cart_url;
      return;
    }

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: "starter-package-bundle",
      cartData: response,
    });

    if (this.cartType === "drawer") {
      this.cart.renderContents(response);
      return;
    }

    window.location = window.routes.cart_url;
  }

  addPackageToCart(submitButton) {
    if (submitButton?.getAttribute("aria-disabled") === "true") return;

    let items;
    let attributes;
    try {
      items = this.getPackageItems();
      attributes = this.getPackageOrderAttributes();
    } catch (error) {
      this.showErrorMessage(error.message);
      return;
    }

    const sections = this.getCartSections();

    const addConfig = fetchConfig("javascript");
    addConfig.headers["X-Requested-With"] = "XMLHttpRequest";
    addConfig.body = JSON.stringify({
      items,
    });

    this.hideErrorMessage();
    this.setLoading(submitButton, true);

    let packageWasAdded = false;
    let addedItemsResponse = null;

    fetch(`${routes.cart_add_url}`, addConfig)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.showErrorMessage(response.description || response.message);
          return null;
        }

        packageWasAdded = true;
        addedItemsResponse = response;
        const updateConfig = fetchConfig("javascript");
        updateConfig.headers["X-Requested-With"] = "XMLHttpRequest";
        updateConfig.body = JSON.stringify({
          attributes,
          sections,
          sections_url: window.location.pathname,
        });

        return fetch(`${routes.cart_update_url}`, updateConfig);
      })
      .then((response) => {
        if (!response) return null;
        return response.json();
      })
      .then(async (response) => {
        if (!response) return;
        if (response.status) {
          throw new Error(response.description || response.message);
        }

        // Local customization: record the successful package selection after Pakke is saved.
        await window.MinimagsCartTimeline?.recordAdd(
          addedItemsResponse,
          { bundleTitle: attributes.Pakke, requestedItems: items },
        );

        this.renderCart(response);
      })
      .catch((error) => {
        console.error(error);
        this.showErrorMessage(
          packageWasAdded
            ? "Pakken er lagt i kurven, men pakkedata kunne ikke gemmes på ordren. Genindlæs siden og kontrollér kurven."
            : "Pakken kunne ikke lægges i kurven. Prøv igen.",
        );
      })
      .finally(() => {
        if (this.cart && this.cart.classList.contains("is-empty")) {
          this.cart.classList.remove("is-empty");
        }
        this.setLoading(submitButton, false);
      });
  }
}

function initStarterPackageBundles(root = document) {
  root.querySelectorAll("starter-package-bundle").forEach((element) => {
    if (element.dataset.starterPackageInitialized === "true") return;
    element.dataset.starterPackageInitialized = "true";
    new StarterPackageBundle(element);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () =>
    initStarterPackageBundles(),
  );
} else {
  initStarterPackageBundles();
}
